import React, {Component} from 'react';
import { BarLoader } from 'react-spinners';
import ReferentDetail from "./ReferentDetail";

class Referenten extends Component {

    render() {
        if (!this.props.referentenList) {
            if (this.props.referenten.isFetching) {
                return <div className={'row'}>
                    <div className={'col-md-12'}>
                        <BarLoader/>
                    </div>
                </div>
            }
            return null
        }

        if (this.props.referentenList.length === 0) {
            return <div>
                <strong>Keine Referenten zu diesem Thema hinterlegt</strong>
            </div>
        }
        return <div>
            <ul className={'list-group referenten'}>
                {
                    this.props.referentenList.map(
                        referent => <ReferentDetail key={referent.id+Math.random()*7} referent={referent} thema={this.props.thema}/>

                    )
                }
            </ul>
        </div>
    }
}

export default Referenten




// WEBPACK FOOTER //
// ./src/components/Referenten.js